/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import { Container, Col, Row } from 'reactstrap';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

const SingleLineObjective = (props) => {
  const {
    index, removeRow, updateRow, name,
  } = props;

  const [nameLine, setNameLine] = useState(name);

  const updateName = (e) => {
    setNameLine(e.target.value);
    updateRow({ name: e.target.value }, index);
  };

  return (
    <Paper style={{ width: '100%', backgroundColor: '#F2F2F2', marginBottom: '10px' }} elevation={2}>
      <ListItem key={index}>
        <Container className="group-creation-container-centered">
          <Row style={{ width: '100%' }}>

            <Col md={11}>
              <TextField
                style={{ backgroundColor: 'white', marginTop: '10px', width: '100%' }}
                id="outlined-helperText"
                key={nameLine}
                defaultValue={nameLine}
                onBlur={(e) => updateName(e)}
                variant="outlined"
              />
            </Col>

            <Col md={1}>
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => removeRow(index)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </Col>
          </Row>
        </Container>
      </ListItem>
    </Paper>

  );
};

SingleLineObjective.propTypes = {
  index: PropTypes.any.isRequired,
  removeRow: PropTypes.any.isRequired,
  updateRow: PropTypes.any.isRequired,
  name: PropTypes.any.isRequired,
};

export default SingleLineObjective;
